import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
//Services
import { ContentService } from "../../../services/content/content.service";

@Component({
  selector: "app-content",
  templateUrl: "./content.page.html",
  styleUrls: ["./content.page.scss"],
})
export class ContentPage implements OnInit {
  type: string;
  id: string;
  news: any;
  webinars: any;
  outstandings: any;
  events: any;
  categories: any;
  subcategories: any;

  constructor(
    private route: ActivatedRoute,
    private contentService: ContentService,
    public languageService: LanguagesService
  ) {}

  async ngOnInit() {
    await this.contentService.getCategories().then((res) => {
    
      this.categories = res
    });
  }

  get getTextsIUPageContentDetail() {
    return this.languageService.textsIU.page_content_detail;
  }
}
